import { render, staticRenderFns } from "./ArchiveAdd.vue?vue&type=template&id=3d28c78b&"
import script from "./ArchiveAdd.vue?vue&type=script&lang=js&"
export * from "./ArchiveAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports